"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getMonth = function getMonth(date) {
  return (0, _dayjs["default"])(date).month();
};

var _default = getMonth;
exports["default"] = _default;